/** Must match BASLER_ICON_RUNTIME in basler-components. */
export const BASLER_ICON_RUNTIME = 'basler-icon-runtime';

export interface BaslerIconRuntime {
  resolve(name: string): string | undefined;
  track?(name: string, svg: string): void;
  request?(names: string[]): void;
}
